import APIClient from '../../../lib/api';

class ServiceTemplateService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: 100,
    };
    
    const queryParams = { ...defaultParams, ...params };
    
    try {
      const response = await APIClient.serviceTemplates.getAll(queryParams);
      return {
        success: true,
        data: response.data || [],
        total: response.data?.length || 0
      };
    } catch (error) {
      console.error('ServiceTemplateService.getAll Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης προτύπων υπηρεσιών'
      };
    }
  }

  async getById(templateId) {
    try {
      const response = await APIClient.serviceTemplates.getById(templateId);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('ServiceTemplateService.getById Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης προτύπου υπηρεσίας'
      };
    }
  }

  async create(templateData) {
    try {
      const response = await APIClient.serviceTemplates.create(templateData);
      return {
        success: true,
        data: response.data,
        message: 'Το πρότυπο υπηρεσίας δημιουργήθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ServiceTemplateService.create Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας προτύπου υπηρεσίας'
      };
    }
  }

  async update(templateId, updateData) {
    try {
      const response = await APIClient.serviceTemplates.update(templateId, updateData);
      return {
        success: true,
        data: response.data,
        message: 'Το πρότυπο υπηρεσίας ενημερώθηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ServiceTemplateService.update Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης προτύπου υπηρεσίας'
      };
    }
  }

  async delete(templateId) {
    try {
      await APIClient.serviceTemplates.delete(templateId);
      return {
        success: true,
        message: 'Το πρότυπο υπηρεσίας διαγράφηκε επιτυχώς'
      };
    } catch (error) {
      console.error('ServiceTemplateService.delete Error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής προτύπου υπηρεσίας'
      };
    }
  }

  validate(templateData) {
    const errors = {};

    if (!templateData.name || templateData.name.trim() === '') {
      errors.name = 'Το όνομα προτύπου είναι υποχρεωτικό';
    }

    if (!templateData.service_type) {
      errors.service_type = 'Ο τύπος υπηρεσίας είναι υποχρεωτικός';
    }

    if (!templateData.default_price || templateData.default_price < 0) {
      errors.default_price = 'Η τιμή πρέπει να είναι μεγαλύτερη ή ίση με 0';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  // Helper methods for form data
  formatServiceType(type) {
    const types = {
      'development': 'Ανάπτυξη',
      'hosting': 'Hosting',
      'maintenance': 'Συντήρηση',
      'seo': 'SEO',
      'design': 'Σχεδιασμός',
      'other': 'Άλλο'
    };
    return types[type] || type;
  }

  formatBillingPeriod(period) {
    const periods = {
      'one_time': 'Εφάπαξ',
      'monthly': 'Μηνιαία Συνδρομή',
      'quarterly': 'Τριμηνιαία Συνδρομή',
      'semi_annual': 'Εξαμηνιαία Συνδρομή',
      'annual': 'Ετήσια Συνδρομή',
      'biennial': 'Διετής Συνδρομή'
    };
    return periods[period] || period;
  }

  formatPrice(price) {
    return `€${parseFloat(price).toFixed(2)}`;
  }

  // Helper method to check if template is subscription
  isSubscriptionTemplate(template) {
    return template.billing_period !== 'one_time';
  }

  // Helper method to get template type description
  getTemplateTypeDescription(template) {
    if (this.isSubscriptionTemplate(template)) {
      return `Συνδρομητική υπηρεσία - ${this.formatBillingPeriod(template.billing_period)}`;
    } else {
      return 'Εφάπαξ υπηρεσία';
    }
  }
}

const serviceTemplateService = new ServiceTemplateService();
export default serviceTemplateService;
